//
// CrosstabHierarchy.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "./CrosstabLabel";
import "./CrosstabLevel";

var CrosstabHierarchy = createModule("BIRD::CrosstabHierarchy", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        variableName: 7,
        name: 7,
        label: 1,
        styleClass: 7,
        levels: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default CrosstabHierarchy;
